const Style = {
    stack: 'space-y-6',
    title: 'text-xl font-semibold text-text-primary',
    description: 'mt-1 text-sm text-text-secondary',
    viewLink: 'mt-4 text-sm',
    integrationList: 'space-y-3',
    integrationCard:
        'flex flex-col gap-4 rounded-lg border border-border bg-surface p-4 sm:flex-row sm:items-center sm:justify-between',
    integrationInfo: 'flex min-w-0 items-center gap-3',
    integrationLogo: 'h-10 w-auto max-w-[6rem] object-contain',
    integrationName: 'truncate text-sm font-semibold text-text-primary',
    integrationService: 'truncate text-xs capitalize text-text-muted',
    integrationContent: 'min-w-0 flex-1 text-sm text-text-secondary',
    integrationButtons: 'flex shrink-0 flex-wrap items-center gap-2',
    dangerCard: 'border-error/30',
};

export default Style;
